/* Daftboy inquiry form: steppers, quantity slider, file picking, validation,
   and upload to daftboy-forms. */
(function () {
	'use strict';

	// Gmail caps a sent email at 25 MB after encoding, which is ~18 MB of files.
	var LIMITS = {
		maxFiles: 10,
		maxTotalBytes: 18 * 1024 * 1024,
		extensions: ['ai', 'eps', 'svg', 'pdf', 'psd', 'png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif', 'zip', 'mp4', 'mov', 'm4v']
	};
	var CUSTOM_SUBJECT_RE = /^\s*(other|something else)\s*$/i;

	function fmtBytes(n) {
		return n > 1024 * 1024 ? (n / 1024 / 1024).toFixed(1) + ' MB' : Math.ceil(n / 1024) + ' KB';
	}

	function escapeHtml(s) {
		return String(s).replace(/[&<>"']/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
		});
	}

	// Follower slider: five equal stretches, 0-1K, 1K-10K, 10K-100K, 100K-1M
	// and 1M-10M, so a creator with 800 and one with 800K can both find
	// themselves. Slider values round to two figures; typed numbers are exact.
	var FOLLOWER_STOPS = [0, 1000, 10000, 100000, 1000000, 10000000];
	var SEG = 200;
	function followersFromPos(pos) {
		var i = Math.min(Math.floor(pos / SEG), FOLLOWER_STOPS.length - 2);
		var t = (pos - i * SEG) / SEG;
		var a = FOLLOWER_STOPS[i], b = FOLLOWER_STOPS[i + 1];
		var v = i === 0 ? a + (b - a) * t : a * Math.pow(b / a, t);
		if (v < 100) return Math.round(v);
		var mag = Math.pow(10, Math.floor(Math.log10(v)) - 1);
		return Math.round(v / mag) * mag;
	}
	function posFromFollowers(v) {
		if (v <= 0) return 0;
		for (var i = 0; i < FOLLOWER_STOPS.length - 1; i++) {
			var a = FOLLOWER_STOPS[i], b = FOLLOWER_STOPS[i + 1];
			if (v <= b) {
				var t = i === 0 ? (v - a) / (b - a) : Math.log(v / a) / Math.log(b / a);
				return Math.round(i * SEG + t * SEG);
			}
		}
		return (FOLLOWER_STOPS.length - 1) * SEG;
	}
	function followerTier(v) {
		if (isNaN(v)) return '';
		if (v < 1000) return 'Just getting started?';
		if (v < 10000) return 'Nano creator.';
		if (v < 100000) return 'Micro creator.';
		if (v < 500000) return 'Mid-tier creator.';
		if (v < 1000000) return 'Macro creator.';
		return 'Mega creator.';
	}

	function initSteppers(form) {
		form.querySelectorAll('[data-db-stepper]').forEach(function (wrap) {
			var input = wrap.querySelector('input');
			var min = parseInt(input.min, 10);
			if (isNaN(min)) min = 1;
			var max = parseInt(input.max, 10) || Infinity;
			var field = wrap.closest('.db-inquiry__field');
			var slider = field.querySelector('[data-db-slider]');
			var followers = slider && slider.getAttribute('data-scale') === 'followers';
			var tier = field.querySelector('[data-db-tier]');

			function paintSlider() {
				if (!slider) return;
				var sMin = parseInt(slider.min, 10);
				var sMax = parseInt(slider.max, 10);
				var pct = ((parseInt(slider.value, 10) - sMin) / (sMax - sMin)) * 100;
				slider.style.setProperty('--fill', pct + '%');
			}

			var dragging = false;
			function syncSlider() {
				if (!slider || dragging) return;
				var v = parseInt(input.value, 10);
				if (tier) tier.textContent = followerTier(v);
				if (followers) slider.value = isNaN(v) ? 0 : posFromFollowers(v);
				else slider.value = isNaN(v) ? slider.min : Math.min(Math.max(v, parseInt(slider.min, 10)), parseInt(slider.max, 10));
				paintSlider();
			}

			function set(v) {
				v = Math.min(Math.max(v, min), max);
				input.value = v;
				input.dispatchEvent(new Event('input', { bubbles: true }));
			}

			wrap.querySelector('[data-step-dec]').addEventListener('click', function () {
				var v = parseInt(input.value, 10);
				set(isNaN(v) ? min : v - 1);
			});
			wrap.querySelector('[data-step-inc]').addEventListener('click', function () {
				var v = parseInt(input.value, 10);
				set(isNaN(v) ? min : v + 1);
			});
			input.addEventListener('input', syncSlider);

			if (slider) {
				slider.addEventListener('input', function () {
					input.value = followers ? followersFromPos(parseInt(slider.value, 10)) : slider.value;
					if (tier) tier.textContent = followerTier(parseInt(input.value, 10));
					paintSlider();
					// Rounded follower counts must not pull the thumb back mid-drag.
					dragging = true;
					input.dispatchEvent(new Event('input', { bubbles: true }));
					dragging = false;
				});
			}
			syncSlider();
		});
	}

	function initCustomSubject(form) {
		var trigger = form.querySelector('[data-db-subject-trigger]');
		var box = form.querySelector('[data-db-custom-subject]');
		if (!trigger || !box) return;
		var input = box.querySelector('input');
		trigger.addEventListener('change', function () {
			var on = CUSTOM_SUBJECT_RE.test(trigger.value);
			box.hidden = !on;
			// Disabled inputs are skipped by validation and not sent.
			input.disabled = !on;
			input.required = on;
			if (on) input.focus();
		});
	}

	// Harness form: show fields for the chosen request type, hide the rest.
	// Hidden fields are disabled, so stale values are never validated or sent.
	function initHarness(form) {
		var trigger = form.querySelector('[data-db-harness-type]');
		if (!trigger) return;
		var details = form.querySelector('textarea[data-db-placeholders]');
		var placeholders = {};
		try { placeholders = JSON.parse(details.getAttribute('data-db-placeholders')); } catch (e) {}
		function setOn(el, on) {
			el.hidden = !on;
			el.querySelectorAll('input, select, textarea').forEach(function (c) { c.disabled = !on; });
		}
		function apply() {
			var opt = trigger.options[trigger.selectedIndex];
			var key = (opt && opt.getAttribute('data-key')) || 'none';
			form.querySelectorAll('[data-db-when]').forEach(function (el) {
				var on = key !== '' && el.getAttribute('data-db-when').split(' ').indexOf(key) !== -1;
				var check = el.getAttribute('data-db-when-check');
				if (on && check) {
					var box = form.querySelector('[data-db-toggle="' + check + '"]');
					on = !!(box && box.checked && !box.disabled);
				}
				setOn(el, on);
			});
			if (details && placeholders[key]) details.placeholder = placeholders[key];
			// Fields that become required only for some request types.
			form.querySelectorAll('[data-db-require-when]').forEach(function (el) {
				var req = el.getAttribute('data-db-require-when').split(' ').indexOf(key) !== -1;
				if (el.hasAttribute('data-db-group')) {
					if (req) el.setAttribute('data-required', ''); else el.removeAttribute('data-required');
				} else {
					el.required = req;
				}
			});
			form.querySelectorAll('[data-db-req-mark]').forEach(function (m) { m.hidden = m.getAttribute('data-db-req-mark') !== key; });
			form.querySelectorAll('[data-db-opt-mark]').forEach(function (m) { m.hidden = m.getAttribute('data-db-opt-mark') === key; });
		}
		trigger.addEventListener('change', apply);
		form.addEventListener('change', function (e) {
			if (e.target.hasAttribute('data-db-toggle')) apply();
		});
		apply();
	}

	function init(form) {
		if (form.__dbInquiry) return;
		form.__dbInquiry = true;

		var root = form.closest('.db-inquiry');
		var startedAt = Date.now();
		var files = [];
		var fileInput = form.querySelector('[data-db-files]');
		var drop = form.querySelector('[data-db-drop]');
		var list = form.querySelector('[data-db-file-list]');
		var errorBox = form.querySelector('[data-db-error]');
		var submit = form.querySelector('[data-db-submit]');
		var submitLabel = form.querySelector('[data-db-submit-label]');
		var defaultLabel = submitLabel.getAttribute('data-default') || 'Send';
		var success = root.querySelector('[data-db-success]');
		var fallback = form.getAttribute('data-fallback-email');

		initSteppers(form);
		initCustomSubject(form);
		initHarness(form);

		var dateInput = form.querySelector('[data-min-today]');
		if (dateInput) {
			var d = new Date();
			dateInput.min = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
		}

		function showError(html) {
			errorBox.innerHTML = html;
			errorBox.hidden = !html;
			if (html) errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}

		function totalBytes() {
			return files.reduce(function (s, x) { return s + x.size; }, 0);
		}

		function renderFiles() {
			list.innerHTML = '';
			files.forEach(function (f, i) {
				var li = document.createElement('li');
				var name = document.createElement('span');
				name.className = 'db-inquiry__file-name';
				name.textContent = f.name;
				var size = document.createElement('span');
				size.className = 'db-inquiry__file-size';
				size.textContent = fmtBytes(f.size);
				var rm = document.createElement('button');
				rm.type = 'button';
				rm.className = 'db-inquiry__file-remove';
				rm.setAttribute('aria-label', 'Remove ' + f.name);
				rm.innerHTML = '&times;';
				rm.addEventListener('click', function () {
					files.splice(i, 1);
					renderFiles();
				});
				li.appendChild(name);
				li.appendChild(size);
				li.appendChild(rm);
				list.appendChild(li);
			});
			drop.classList.toggle('has-files', files.length > 0);
		}

		function addFiles(incoming) {
			var problems = [];
			Array.prototype.forEach.call(incoming, function (f) {
				var ext = f.name.indexOf('.') > -1 ? f.name.split('.').pop().toLowerCase() : '';
				if (LIMITS.extensions.indexOf(ext) === -1) problems.push('"' + f.name + '" is not an accepted file type.');
				else if (files.length >= LIMITS.maxFiles) problems.push('You can attach up to ' + LIMITS.maxFiles + ' files.');
				else if (totalBytes() + f.size > LIMITS.maxTotalBytes) problems.push('"' + f.name + '" would put you over 18 MB total.');
				else if (!files.some(function (x) { return x.name === f.name && x.size === f.size; })) files.push(f);
			});
			renderFiles();
			showError(problems.length
				? problems.map(escapeHtml).join('<br>') + '<br>For bigger files, paste a Google Drive or Dropbox link in your project details.'
				: '');
		}

		fileInput.addEventListener('change', function () {
			addFiles(fileInput.files);
			fileInput.value = '';
		});
		['dragenter', 'dragover'].forEach(function (ev) {
			drop.addEventListener(ev, function (e) {
				e.preventDefault();
				drop.classList.add('is-dragging');
			});
		});
		['dragleave', 'drop'].forEach(function (ev) {
			drop.addEventListener(ev, function (e) {
				e.preventDefault();
				drop.classList.remove('is-dragging');
			});
		});
		drop.addEventListener('drop', function (e) {
			if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
		});

		function clearFieldErrors() {
			form.querySelectorAll('.db-inquiry__field.is-invalid').forEach(function (el) {
				el.classList.remove('is-invalid');
				var msg = el.querySelector('.db-inquiry__field-error');
				if (msg) msg.remove();
			});
		}

		function markField(name, message) {
			var input = form.querySelector('[name="' + name + '"]');
			if (!input) return;
			var field = input.closest('.db-inquiry__field');
			field.classList.add('is-invalid');
			input.setAttribute('aria-invalid', 'true');
			var msg = document.createElement('p');
			msg.className = 'db-inquiry__field-error';
			msg.textContent = message;
			var anchor = input.closest('[data-db-stepper]') || input.closest('.db-inquiry__chips') || input;
			anchor.insertAdjacentElement('afterend', msg);
		}

		function clearOne(target) {
			var field = target.closest('.db-inquiry__field.is-invalid');
			if (!field) return;
			field.classList.remove('is-invalid');
			target.removeAttribute('aria-invalid');
			var msg = field.querySelector('.db-inquiry__field-error');
			if (msg) msg.remove();
		}
		form.addEventListener('input', function (e) { clearOne(e.target); });
		form.addEventListener('change', function (e) { clearOne(e.target); });

		function setBusy(busy, label) {
			submit.disabled = busy;
			submit.classList.toggle('is-busy', busy);
			submitLabel.textContent = label || defaultLabel;
		}

		function fallbackMessage(text) {
			return escapeHtml(text || 'Something went wrong.') +
				' You can also email us at <a href="mailto:' + escapeHtml(fallback) + '">' + escapeHtml(fallback) + '</a>.';
		}

		function fields() {
			// Named, enabled controls only: skips the slider, a hidden subject box
			// and unticked checkboxes.
			return Array.prototype.filter.call(
				form.querySelectorAll('input[name]:not(:disabled), select[name]:not(:disabled), textarea[name]:not(:disabled)'),
				function (el) { return (el.type !== 'checkbox' && el.type !== 'radio') || el.checked; }
			);
		}

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			clearFieldErrors();
			showError('');

			var firstBad = null;
			fields().forEach(function (el) {
				if (el.name === 'website' || el.checkValidity()) return;
				var label = form.querySelector('label[for="' + el.id + '"]');
				var text = label ? label.textContent.replace('*', '').trim() : 'This field';
				var msg = el.validity.valueMissing ? text + ' is required'
					: (el.validity.badInput || el.validity.stepMismatch || el.validity.rangeUnderflow) ? 'Enter a whole number'
					: el.validationMessage;
				markField(el.name, msg);
				if (!firstBad) firstBad = el;
			});
			// Checkbox groups: at least one box ticked.
			form.querySelectorAll('[data-db-group][data-required]').forEach(function (group) {
				if (group.querySelector('input:checked')) return;
				var first = group.querySelector('input');
				var legend = group.querySelector('legend');
				var text = legend ? legend.firstChild.textContent.trim() : 'This field';
				markField(first.name, 'Pick at least one: ' + text.replace(/\?$/, ''));
				if (!firstBad) firstBad = first;
			});
			if (firstBad) {
				firstBad.focus();
				return;
			}

			var data = new FormData();
			fields().forEach(function (el) { data.append(el.name, el.value); });
			files.forEach(function (f) { data.append('attachments', f, f.name); });
			data.append('_elapsed', String(Date.now() - startedAt));
			data.append('_page', window.location.href.split('?')[0]);

			var xhr = new XMLHttpRequest();
			xhr.open('POST', form.action);
			xhr.responseType = 'json';
			xhr.timeout = 180000;
			if (files.length) {
				xhr.upload.addEventListener('progress', function (ev) {
					if (ev.lengthComputable) setBusy(true, 'Uploading ' + Math.round((ev.loaded / ev.total) * 100) + '%');
				});
				xhr.upload.addEventListener('load', function () { setBusy(true, 'Sending...'); });
			}
			xhr.addEventListener('load', function () {
				var body = xhr.response || {};
				if (xhr.status === 200 && body.ok) {
					success.querySelector('[data-db-ref]').textContent = body.id;
					root.classList.add('is-sent');
					form.hidden = true;
					success.hidden = false;
					success.focus();
					root.scrollIntoView({ behavior: 'smooth', block: 'start' });
					return;
				}
				setBusy(false);
				if (body.fields) {
					Object.keys(body.fields).forEach(function (k) { markField(k, body.fields[k]); });
					showError(escapeHtml(body.error || 'Please fix the highlighted fields.'));
				} else {
					showError(fallbackMessage(body.error));
				}
			});
			function networkFail() {
				setBusy(false);
				showError(fallbackMessage('We could not reach our server.'));
			}
			xhr.addEventListener('error', networkFail);
			xhr.addEventListener('timeout', networkFail);

			setBusy(true, files.length ? 'Uploading 0%' : 'Sending...');
			xhr.send(data);
		});
	}

	// A link can preselect "What can we help you with?" with ?inquiry=<word>,
	// matched case-insensitively against the option text. The rush link on the
	// custom fan product card uses ?inquiry=rush#quote to land on
	// "Rush Order / Event Deadline".
	function prefillInquiry(form) {
		var want;
		try { want = (new URLSearchParams(window.location.search).get('inquiry') || '').trim().toLowerCase(); } catch (e) { return; }
		if (!want) return;
		var select = form.querySelector('select[name="inquiry_type"]');
		if (!select || select.value) return;
		var match = Array.prototype.find.call(select.options, function (o) {
			return o.value && o.value.toLowerCase().indexOf(want) !== -1;
		});
		if (!match) return;
		select.value = match.value;
		select.dispatchEvent(new Event('change', { bubbles: true }));
	}

	// Shipping address on the custom fan form: United States by default, the
	// state list follows the country (from country_option_tags' data-provinces),
	// labels switch between State/ZIP code and State-Province/Postal code, and a
	// 5-digit US ZIP fills in the city and state from api.zippopotam.us. A
	// lookup only fills a city the shopper has not typed themselves.
	function initAddress(form) {
		var box = form.querySelector('[data-db-address]');
		if (!box) return;
		var country = box.querySelector('[data-db-country]');
		var province = box.querySelector('[data-db-province]');
		var provinceWrap = box.querySelector('[data-db-province-wrap]');
		var provinceLabel = box.querySelector('[data-db-province-label]');
		var zip = box.querySelector('[data-db-zip]');
		var zipLabel = box.querySelector('[data-db-zip-label]');
		var city = box.querySelector('[data-db-city]');
		var isUS = function () { return country.value === 'United States'; };

		var def = country.getAttribute('data-default');
		if (def && Array.prototype.some.call(country.options, function (o) { return o.value === def; })) country.value = def;

		function fillProvinces() {
			var opt = country.options[country.selectedIndex];
			var list = [];
			try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) {}
			var keep = province.value;
			province.innerHTML = '<option value="">Choose one</option>' + list.map(function (p) {
				return '<option value="' + escapeHtml(p[0]) + '">' + escapeHtml(p[1]) + '</option>';
			}).join('');
			if (keep) province.value = keep;
			provinceWrap.hidden = !list.length;
			province.disabled = !list.length;
			provinceLabel.textContent = isUS() ? 'State' : 'State / Province';
			zipLabel.textContent = isUS() ? 'ZIP code' : 'Postal code';
		}
		country.addEventListener('change', fillProvinces);
		fillProvinces();

		var cityAuto = false;
		city.addEventListener('input', function () { cityAuto = false; });
		var lastZip = '';
		function lookup() {
			var z = (zip.value || '').trim().slice(0, 5);
			if (!isUS() || !/^\d{5}$/.test(z) || z === lastZip) return;
			lastZip = z;
			fetch('https://api.zippopotam.us/us/' + z).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
				var place = d && d.places && d.places[0];
				if (!place || zip.value.trim().slice(0, 5) !== z) return;
				if (!city.value || cityAuto) { city.value = place['place name']; cityAuto = true; }
				var st = place.state;
				if (Array.prototype.some.call(province.options, function (o) { return o.value === st; })) province.value = st;
			}).catch(function () {});
		}
		zip.addEventListener('input', lookup);
		zip.addEventListener('change', lookup);
	}

	function initAll() {
		document.querySelectorAll('form[data-db-inquiry]').forEach(function (form) {
			init(form);
			prefillInquiry(form);
			initAddress(form);
		});
	}

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
	else initAll();
	// Theme editor re-renders sections in place.
	document.addEventListener('shopify:section:load', initAll);
})();
